import {useMemo} from 'react';
import {useOperationsContext} from '../../../../../context/OperationsContextProvider';
import {SVG} from '../../../../../constants/assetLists';

const FILTERS = [
  {type: 'Error', icon: SVG.redTriangleIcon, count: 0},
  {type: 'Regular', icon: SVG.regularAnnouncementIcon, count: 0},
  {type: 'Training', icon: SVG.tutorialsActiveIcon, count: 0},
  {type: 'Administration', icon: SVG.settingBlackIcon, count: 0},
  {type: 'Regulation', icon: SVG.administrationSmallIcon, count: 0},
  {type: 'Quick', icon: SVG.quickTypeIcon, count: 0},
  {type: 'Reservation', icon: SVG.tableIcon, count: 0},
];

export default function FilterTopBar() {
  const {
    announcementTypeFilter,
    setAnnouncementTypeFilter,
    groupedAnnouncementByType,
  } = useOperationsContext();

  const filters = useMemo(() => {
    return FILTERS.map(filter => {
      const count = groupedAnnouncementByType?.[filter.type] || 0;
      return {...filter, count};
    });
  }, [groupedAnnouncementByType]);

  const handleFilterTypeChange = (type: string) => {
    setAnnouncementTypeFilter(type);
  };

  return (
    <div className="grid items-center grid-cols-7 gap-3">
      {filters.map(filter => {
        const selected = announcementTypeFilter === filter.type;
        const isFault = filter.type === 'Error';
        const isCount = filter.count > 0;

        return (
          <button
            key={filter.type}
            type="button"
            disabled={!isCount}
            onClick={() => handleFilterTypeChange(filter.type)}
            className={`flex flex-col items-center gap-2 border-none outline-none ${
              isCount ? 'opacity-100' : 'opacity-50 cursor-not-allowed'
            }`}>
            <img
              src={filter.icon}
              alt={filter.type}
              className="w-[24px] h-[24px] object-contain"
            />

            <div
              className={`px-[16px] py-1 flex items-center ${
                selected ? 'rounded-lg bg-brightYellow' : ''
              }`}>
              <span
                className={`text-[24px] leading-[24px] ${
                  isFault ? 'text-raspberryRed' : 'text-darkGray'
                }`}>
                {filter.count}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
